export default "__VITE_ASSET__DfUe2yNC__"